const configEndpoint = process.env.VUE_APP_ENDPOINT_URL!==undefined?process.env.VUE_APP_ENDPOINT_URL:""
const firebaseWebApi = process.env.VUE_APP_FIREBASE_WEB_API_KEY
const authDomain = process.env.VUE_APP_AUTH_DOMAIN
const appEnv = process.env.VUE_APP_ENV!==undefined?process.env.VUE_APP_ENV:""


exports.configEndpoint = configEndpoint
exports.firebaseWebApi = firebaseWebApi
exports.authDomain = authDomain
exports.appEnv = appEnv